export class PoliceTax {
    public id: number;
    public amount: number;
    public date: Date;
    
    constructor() {
   
    }
  
  }  